import { render, staticRenderFns } from "./PresentationPlayDemo.vue?vue&type=template&id=3d54547e&scoped=true&"
import script from "./PresentationPlayDemo.vue?vue&type=script&lang=js&"
export * from "./PresentationPlayDemo.vue?vue&type=script&lang=js&"
import style0 from "./PresentationPlayDemo.vue?vue&type=style&index=0&id=3d54547e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54547e",
  null
  
)

export default component.exports